import { render, staticRenderFns } from "./LogoView.vue?vue&type=template&id=a5f4ed84&"
import script from "./LogoView.vue?vue&type=script&lang=js&"
export * from "./LogoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports